import React, { useState } from "react";
import './Header.css'
const Header = () => {
const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="header_header__1OXnM">
            <div className="container_container__ZgtMu header_container__XSEN0">
                <div className="header_logo__SX7rD">
                    <a href="/">
                        <img alt="Hachiko" loading="lazy" width="347" height="117"
                            decoding="async" data-nimg="1" className="d-md" style={{ color: "transparent" }} src="images/logo.jpg" />
                        <img alt="Hachiko" loading="lazy" width="139" height="99"
                            decoding="async" data-nimg="1" className="d-sm" style={{ color: "transparent" }} src="images/logo.jpg" />
                    </a>
                </div>
                <nav className={isMenuOpen ? "mobile-nav open" : "mobile-nav"} id="mobile-nav">
                    <ul>
                        <li><a href="/#hopenomics">Tokenomics</a></li>
                        <li><a href="/#roadmap">Roadmap</a></li>
                        <li><a href="/#how-to-buy">How to Buy</a></li>
                        <li><a href="/#referral">Referral Programme</a></li>
                       
                    </ul>
                </nav>
                <div className="header_right__MrQsU">
                    <a href="/#buy" className="button_button___iXOl button_purple__CR140">
                        <span>Buy <span className="d-md">now</span></span>
                    </a>
                    <button className="header_hamburger__nCheC d-sm" id="hamburger-btn" onClick={toggleMenu}>
                        <span></span><span></span><span></span>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;
